export default __webpack_public_path__ + "static/media/home-interior-design-slider-img02.09253a9b.jpg";